import React from 'react'
import { TextProps } from 'rebass'
import { SStyled, useSTheme } from 'styles/theme'
import SFlex from './opinionless/SFlex'

type Props = TextProps

const PageHeader: React.FC<Props> = (props: Props) => {
    const PageHeaderStyled = SStyled(SFlex)`
    @media screen and (max-width: ${(p) => p.theme.breakpoints[0]}) {
        color: white;
    }
`
    const theme = useSTheme()
    return (
        <PageHeaderStyled
            sx={{
                bg: [theme.colors.secondaryColor, 'transparent', 'transparent'],
                color: [theme.colors.textColor || theme.colors.secondaryColor],
            }}
            fontSize={['24px', 5, 5]}
            fontWeight="extraBold"
            px={[6, 0, 0]}
            py={[6, 0, 0]}
            mb={[7, 10, 10]}
            {...props}
        />
    )
}

export default PageHeader
